import React from 'react';

/**
 * the shared code for block and inline version of the NCH logo
 */
const NchLogoBase = (props) => {    
    return (    
        <img  key={props.objectkey} 
            className = {`nchLogo ${props.field.class || ""}`} 
            src={props.logourl}                             
        />
    );
}

export default NchLogoBase;